import { Title, DesignTokens } from "melco-ui";
import styled from "styled-components";

const { spacings } = DesignTokens;

export const ReferencesListTitle = styled(Title)`
  margin: 0 ${spacings.xlarge}px;
`;
